import {firstMonthDay, today} from "./constants";
import {formatDate} from "./utils/format-date";
import {mapState} from "vuex";

export default {
  data: () => ({
    dates: firstMonthDay === today ? [today] : [firstMonthDay, today],
    selectedTerminals: []
  }),
  computed: {
    ...mapState('terminals', ['terminals']),
    dateInputValue() {
      return [...this.dates].sort().reduce((acc, next, index) => {
        const dateString = formatDate(next)
        return acc + (index > 0 ? ' - ' : '') + dateString
      }, '')
    },
    today() {
      return today
    }
  },
  watch: {
    dates() { this.emitFilters() },
    selectedTerminals() { this.emitFilters() }
  },
  methods: {
    emitFilters() {
      const sortedDates = [...this.dates].sort();

      const startDate = sortedDates[0];
      const endDate = sortedDates.length > 1 ? sortedDates[1] : sortedDates[0];

      this.$emit('filter-change', {
        startDate: startDate,
        endDate: endDate,
        terminals: [...this.selectedTerminals]
      })
    }
  },
  created() {
    this.emitFilters()
  }
}